import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import AppStoreIcon from '../../../static/images/appstore_bt.svg';
import GooglePlayIcon from '../../../static/images/googleplay_bt.svg';

const AppIcons = ({ baseClassName = 'c-appIcons', modifier = null }) => {
  let className = baseClassName;

  if (modifier) {
    if (modifier.constructor === Array) {
      className = modifier.map(mod => `${className} ${baseClassName}--${mod}`);
    } else {
      className += ` ${baseClassName}--${modifier}`;
    }
  }

  return (
    <ul className={className}>
      <li>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://itunes.apple.com/GB/app/id519652671?mt=8"
        >
          <LazyLoad once offset={100} height={0}>
            <img src={AppStoreIcon} alt="AppStore" />
          </LazyLoad>
        </a>
      </li>
      <li>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://play.google.com/store/apps/details?id=com.justpark.jp"
        >
          <LazyLoad once offset={100} height={0}>
            <img src={GooglePlayIcon} alt="Google Play" />
          </LazyLoad>
        </a>
      </li>
    </ul>
  );
};

AppIcons.propTypes = {
  baseClassName: PropTypes.string,
  modifier: PropTypes.string
};

AppIcons.defaultProps = {
  baseClassName: 'c-appIcons',
  modifier: null
};

export default AppIcons;
